export default {
  computed: {
    item() {
      return this.myOrder.productItem;
    },
    variantId() {
      return this.myOrder.productVariantId;
    },
    variant() {
      return this._.find(this.item.variants, {id: this.variantId});
    },
    bulkPrices() {
      return this._.first(this.variant.pricelist_product_variants).bulk_prices;
    },
  },
  methods: {
    next(bulkPrice) {
      this.$store.dispatch('SET_BULK_PRICE', bulkPrice);
      this.$store.dispatch('ADD_PREV_ORDER_STEP', this.orderStep);
      this.$store.dispatch('SET_ORDER_STEP', `${this._.first(
          this.orderStep.split('-'))}-${this.product.slug}-more-photos`);
    },
  },
};
